var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurePaymentsMinimalistic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 272,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.599 0H43.943C19.716 0 0 19.716 0 43.943v147.923c0 24.227 19.716 43.943 43.943 43.943H169.63a9.53 9.53 0 000-19.059H43.943c-13.723 0-24.883-11.161-24.883-24.884V115.31h277.422v16.307a9.53 9.53 0 0019.06 0V43.954C315.542 19.726 295.826 0 271.599 0zM43.943 19.07h227.656c13.723 0 24.883 11.16 24.883 24.883v9.054H19.06v-9.053c0-13.723 11.16-24.884 24.883-24.884zM19.06 96.24V72.077h277.422V96.24H19.06z",
    fill: "url(#paint0_linear_1065_2099)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.142 154.349h29.193a9.53 9.53 0 000-19.059H55.142a9.53 9.53 0 000 19.059zm0 35.885h58.386a9.53 9.53 0 000-19.06H55.142a9.53 9.53 0 000 19.06zm208.512-2.573l-17.058 13.755-3.706-4.723c-3.241-4.119-9.244-4.871-13.384-1.609a9.533 9.533 0 00-1.621 13.384l9.668 12.325a9.553 9.553 0 007.497 3.653c2.17 0 4.277-.741 5.982-2.107l24.577-19.811c4.097-3.315 4.743-9.308 1.44-13.406-3.294-4.119-9.297-4.754-13.395-1.461z",
    fill: "url(#paint1_linear_1065_2099)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M304.222 161.561l-42.482-21.357c-5.792-2.902-12.674-2.912-18.456.01l-42.46 21.336c-7.063 3.537-11.499 10.938-11.33 18.848.445 20.267 6.374 69.525 51.641 89.188a28.628 28.628 0 0011.383 2.362c3.886 0 7.761-.784 11.372-2.362 45.266-19.652 51.196-68.921 51.641-89.177.19-7.91-4.257-15.312-11.309-18.848zm-47.924 90.554a9.593 9.593 0 01-7.571 0c-35.176-15.269-39.824-55.527-40.184-72.13a1.523 1.523 0 01.826-1.408l42.45-21.336c.222-.106.455-.17.688-.17.233 0 .455.053.667.159l42.482 21.357c.519.255.826.784.815 1.398-.36 16.603-5.008 56.851-40.173 72.13z",
    fill: "url(#paint2_linear_1065_2099)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1065_2099",
    x1: 157.771,
    y1: 0,
    x2: 157.771,
    y2: 235.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024EC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1065_2099",
    x1: 162.386,
    y1: 135.29,
    x2: 162.386,
    y2: 224.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024EC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1065_2099",
    x1: 252.513,
    y1: 138.025,
    x2: 252.513,
    y2: 271.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024EC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurePaymentsMinimalistic);
export default __webpack_public_path__ + "static/media/secure-payments-minimalistic.a8a00aae3c96882786c609dc0940d526.svg";
export { ForwardRef as ReactComponent };